import { ViewerTypeEnum } from 'app/enums/ViewerTypeEnum'

export class OpenColsValidationError extends Error {
  private readonly questionKey: string
  private readonly rowKey: string
  private readonly type: ViewerTypeEnum

  constructor(type: ViewerTypeEnum, questionKey: string, rowKey: string) {
    super()
    this.questionKey = questionKey
    this.rowKey = rowKey
    this.type = type

    this.name = 'Invalid values received from server'
    this.message = `A ${type} question (${questionKey}) has at least one incorrect value in the openCols property of its row (${rowKey}). Each statement key in the openCols should be set to TRUE.`
  }

  compareKeyValues(openColKeys: string[], statementKeys: string[]) {
    this.message = `A ${this.type} question (${this.questionKey}) does not have all the expected statement keys in the openCols for a row (${this.rowKey}). The openCols keys (${openColKeys.join(', ')}) must hold all the statement keys (${statementKeys.join(', ')})`
    return this
  }

  missingOpenCols() {
    this.message = `A ${this.type} question (${this.questionKey}) is missing the openCols property.`
    return this
  }
}
